app.controller("LoginController", ["$scope", "AuthService", "$state", "$timeout",
    function ($scope, AuthService, $state, $timeout) {
        $scope.loading = false;
        $scope.submit = function () {
            $scope.loading = true;
            $scope.status = null;
            if(!$scope.email || $scope.email.length === 0 || !$scope.password || $scope.password.length === 0) {
                $timeout(function() {
                    $scope.loading = false;
                    $scope.status = 'error';
                },1000);
                return;
            }
            AuthService.login($scope.email, $scope.password).then(function () {
                $scope.loading = false;
                if (AuthService.secondStep) {
                    $state.go('verify-phone');
                } else if (AuthService.needTwoFactor) {
                    $state.go('two-factor-auth');
                } else if (AuthService.needSmsAuth) {
                    $state.go('sms-auth');
                } else {
                    $state.go("profile");
                }
            }).catch(function (err) {
                $timeout(function () {
                    $scope.loading = false;
                    if (err === 400 || err === 403) {
                        $scope.status = 'error';
                    }
                }, 1000);

            });
        };

        $scope.facebookLogin = function () {
            AuthService.fb().then(function (data) {
                console.log(data)
            })
        }
    }
]);
